/* @generated from adl module ferovinum.sourcecontracts.supplier */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.supplier` contract.
 */
export interface SupplierSource {
  id: ferovinum_app_db.SupplierId;
  name: common_strings.StringNE;
  shortName: (common_strings.StringNE|null);
  contactName: common_strings.StringNE;
  contactMobile: common_strings.StringNE;
  contactEmail: common_strings.StringNE;
  locale: common_strings.StringNE;
  status: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
  bankAccountId: (ferovinum_app_db.BankAccountId|null);
}

export function makeSupplierSource(
  input: {
    id: ferovinum_app_db.SupplierId,
    name: common_strings.StringNE,
    shortName: (common_strings.StringNE|null),
    contactName: common_strings.StringNE,
    contactMobile: common_strings.StringNE,
    contactEmail: common_strings.StringNE,
    locale: common_strings.StringNE,
    status: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
    bankAccountId: (ferovinum_app_db.BankAccountId|null),
  }
): SupplierSource {
  return {
    id: input.id,
    name: input.name,
    shortName: input.shortName,
    contactName: input.contactName,
    contactMobile: input.contactMobile,
    contactEmail: input.contactEmail,
    locale: input.locale,
    status: input.status,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
    bankAccountId: input.bankAccountId,
  };
}

const SupplierSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.supplier","decl":{"annotations":[{"value":{"modelName":"source__app_db.supplier","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.supplier` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SupplierId"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"shortName","default":{"kind":"nothing"},"name":"shortName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"contactName","default":{"kind":"nothing"},"name":"contactName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactMobile","default":{"kind":"nothing"},"name":"contactMobile","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"locale","default":{"kind":"nothing"},"name":"locale","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"bankAccountId","default":{"kind":"nothing"},"name":"bankAccountId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"BankAccountId"}},"parameters":[]}]}}]}},"name":"SupplierSource","version":{"kind":"nothing"}}};

export const snSupplierSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.supplier", name:"SupplierSource"};

export function texprSupplierSource(): ADL.ATypeExpr<SupplierSource> {
  return {value : {typeRef : {kind: "reference", value : snSupplierSource}, parameters : []}};
}

/**
 * The published `source__app_db.supplier__approved_currencies_unpack` contract (fanout sibling).
 */
export interface SupplierApprovedCurrenciesUnpackSource {
  supplierId: ferovinum_app_db.SupplierId;
  approvedCurrenciesIdx: number;
  approvedCurrency: (common_strings.StringNE|null);
}

export function makeSupplierApprovedCurrenciesUnpackSource(
  input: {
    supplierId: ferovinum_app_db.SupplierId,
    approvedCurrenciesIdx: number,
    approvedCurrency: (common_strings.StringNE|null),
  }
): SupplierApprovedCurrenciesUnpackSource {
  return {
    supplierId: input.supplierId,
    approvedCurrenciesIdx: input.approvedCurrenciesIdx,
    approvedCurrency: input.approvedCurrency,
  };
}

const SupplierApprovedCurrenciesUnpackSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.supplier","decl":{"annotations":[{"value":{"modelName":"source__app_db.supplier__approved_currencies_unpack","grain":["supplier_id","approved_currencies_idx"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.supplier__approved_currencies_unpack` contract (fanout sibling).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"supplierId","default":{"kind":"nothing"},"name":"supplierId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SupplierId"}},"parameters":[]}},{"annotations":[],"serializedName":"approvedCurrenciesIdx","default":{"kind":"nothing"},"name":"approvedCurrenciesIdx","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"approvedCurrency","default":{"kind":"nothing"},"name":"approvedCurrency","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"SupplierApprovedCurrenciesUnpackSource","version":{"kind":"nothing"}}};

export const snSupplierApprovedCurrenciesUnpackSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.supplier", name:"SupplierApprovedCurrenciesUnpackSource"};

export function texprSupplierApprovedCurrenciesUnpackSource(): ADL.ATypeExpr<SupplierApprovedCurrenciesUnpackSource> {
  return {value : {typeRef : {kind: "reference", value : snSupplierApprovedCurrenciesUnpackSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.supplier.SupplierSource" : SupplierSource_AST,
  "ferovinum.sourcecontracts.supplier.SupplierApprovedCurrenciesUnpackSource" : SupplierApprovedCurrenciesUnpackSource_AST
};
